import { render, staticRenderFns } from "./Importacao.vue?vue&type=template&id=b0e1a4e8&scoped=true"
import script from "./Importacao.vue?vue&type=script&lang=js"
export * from "./Importacao.vue?vue&type=script&lang=js"
import style0 from "./Importacao.vue?vue&type=style&index=0&id=b0e1a4e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0e1a4e8",
  null
  
)

export default component.exports